import { MatDialogConfig } from '@angular/material/dialog';

export const SubmitToEwaCheckmarkDialogConfig: MatDialogConfig = {
    panelClass: 'application-completion-dialog',
    disableClose: true,
} as const;
